import { atom, DefaultValue, RecoilState, selector } from 'recoil';

export enum ToastSeverity {
  error = 'error',
  warning = 'warning',
  success = 'success',
  info = 'info',
}

type ToastState = {
  isOpen: boolean;
  message?: string;
  severity?: ToastSeverity;
};

export const toastState: RecoilState<ToastState> = atom<ToastState>({
  key: 'toastState',
  default: {
    isOpen: false,
    message: '',
    severity: ToastSeverity.info,
  },
});

export const toastStateSelector: RecoilState<ToastState> = selector<ToastState>(
  {
    key: 'toastStateSelector',
    get: ({ get }) => get(toastState),
    set: ({ set }, values) => {
      if (values instanceof DefaultValue) {
        return set(toastState, values);
      }
      set(toastState, values);
    },
  },
);
